"use strict";
define(
'stores/email-activity-details',[
    "jquery",
    "stores/store",
    "actions/email-activity-details",
    "constants/actiontypes"
],
function ($, StoreBase, Action, Constants)
{
    Store.prototype = new StoreBase();
    Store.constructor = Store;

    var PAGE_SIZE = 20;

    function Store (params)
    {
        // Call parent constructor
        StoreBase.call(this, params);

        this.registerDispatchListener(function (action) {
            switch(action.actionType) {
                case Constants.INIT_EMAIL_ACTIVITY_DETAILS:
                    if(!this.emailActivityDetails)
                        this.emailActivityDetails = [];

                    _.each(action.data, function (data, index, list) {
                        this.addEmailActivityDetail(data);
                    }, this);
                    this.initFilteredResults();
                    this.event.emit("change");
                    break;
            }
        }.bind(this));

        this.action = new Action();
        this.status = null;
    }

    Store.prototype.pull = function(buncee_guid) {
        this.emailActivityDetails = {};
        this.filteredResults = [];
        this.action.pull(buncee_guid);
    }

    Store.prototype.addEmailActivityDetail = function(data) {
        switch(data.status) {
            case 'open':
                data.status = 'opened';
                break;
            case 'click':
                data.status = 'clicked';
                break;
            default:
                break;
        }

        this.emailActivityDetails[data.guid] = data;
    }

    Store.prototype.getAll = function(page) {
        if(this.filteredResults.length == 0 && this.emailActivityDetails.length == 0)
            return null;

        var ret = this.filteredResults.slice(page*PAGE_SIZE, (page+1)*PAGE_SIZE);
        return ret;
    }

    Store.prototype.getMaxPage = function() {
        if(this.filteredResults.length <= 0)
            return 0;
        
        return Math.floor((this.filteredResults.length-1) / PAGE_SIZE);
    }

    Store.prototype.refresh = function(buncee_guid) {
        this.emailActivityDetails = {};
        this.filteredResults = [];
        this.event.emit("change");
        this.action.pull(buncee_guid);
    }

    Store.prototype.initFilteredResults = function() {
        var self = this;

        this.filteredResults = [];
        _.each(this.emailActivityDetails, function(ead) {
            if(self.status == null || self.status == ead.status)
                self.filteredResults.push(ead);
        });

        this.filteredResults.sort(function(a, b) {
            var aVal = a[self.sortName];
            var bVal = b[self.sortName];

            var result;

            // Data sort type is String
            if(self.sortType == "string") {
                result = aVal.localeCompare(bVal);
            }
            // Data sort type is date
            else if(self.sortType == "date") {
                aVal = aVal.getTime();
                bVal = bVal.getTime();

                if(aVal > bVal)
                    result = -1;
                else if(aVal < bVal)
                    result = 1;
                else
                    result = 0;
            }

            if(self.sortAsc)
                result *= -1;

            return result;
        });
    }

    Store.prototype.initFilter = function(status) {
        if(status == "all")
            status = null;

        this.status = status;
        this.initFilteredResults();
    }

    Store.prototype.initSort = function(name, type, isAsc) {
        this.sortName = name;
        this.sortType = type;
        this.sortAsc = isAsc;

        this.initFilteredResults();
    }

    return Store;
});

